export var IEditLeadAccessPayloadEnum;
(function (IEditLeadAccessPayloadEnum) {
    IEditLeadAccessPayloadEnum["EDIT_FLAG"] = "edit";
    IEditLeadAccessPayloadEnum["SPLIT_FLAG"] = "split";
})(IEditLeadAccessPayloadEnum || (IEditLeadAccessPayloadEnum = {}));
